import { useCallback } from "react";
import { useSDK } from "@contentful/react-apps-toolkit";
import { GlossaryId } from "../lib";
import { getPlanFromCredentials } from "../utils";

export const useDeleteDeeplGlossary = () => {
    const sdk = useSDK();
    const deeplCredentials = sdk.parameters.installation.deeplApiKey;

    const deleteDeeplGlossary = useCallback(
        async (id: GlossaryId): Promise<void> => {
            if (!deeplCredentials) {
                throw new Error("Missing DeepL credentials");
            }

            const plan = getPlanFromCredentials(deeplCredentials);

            const response = await fetch(`/api/${plan}/v3/glossaries/${id}`, {
                method: "DELETE",
                headers: {
                    Authorization: `DeepL-Auth-Key ${deeplCredentials}`,
                    Connection: "keep-alive",
                },
            });

            if (!response.ok) {
                throw new Error(`Error deleting DeepL glossary. Status: ${response.status}`);
            }
        },
        [deeplCredentials]
    );
    return { deleteDeeplGlossary };
};
